/* src/app/pages/ui-kit/ui-kit.component.scss */
.container {
  width: 800px;
  margin: 0 auto;
  height: 100vh;
  overflow: auto;
  scrollbar-width: none;
}
@media (max-width: 1199px) {
  .container {
    width: calc(100% - 20px);
  }
}
.container .p-tabpanels {
  overflow: scroll;
}
.container .box {
  display: flex;
  gap: 14px;
  align-items: center;
}
/*# sourceMappingURL=ui-kit.component.css.map */
